import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=40573bfe"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"
import style0 from "./forget.vue?vue&type=style&index=0&id=40573bfe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports